import { INVOICE_STATUS_LABELS, type INVOICE_STATUSES } from '@platform/contracts';
import { Badge, type BadgeProps } from '@platform/ui';
import {
  Ban,
  CheckCircle2,
  CircleSlash,
  Clock3,
  FilePen,
  FileText,
  FlaskConical,
  PauseCircle,
  Send,
  XCircle,
  type LucideIcon,
} from 'lucide-react';

type Tone = NonNullable<BadgeProps['variant']>;

/** Estado con ícono (el color nunca va solo). */
export function StatusBadge({
  label,
  tone,
  icon: Icon,
}: {
  label: string;
  tone: Tone;
  icon: LucideIcon;
}) {
  return (
    <Badge variant={tone} dot={false}>
      <Icon aria-hidden />
      {label}
    </Badge>
  );
}

export const SUB_STATUS: Record<string, { label: string; tone: Tone; icon: LucideIcon }> = {
  trialing: { label: 'En prueba', tone: 'default', icon: FlaskConical },
  active: { label: 'Activa', tone: 'success', icon: CheckCircle2 },
  past_due: { label: 'Pago vencido', tone: 'warning', icon: Clock3 },
  suspended: { label: 'Suspendida', tone: 'destructive', icon: PauseCircle },
  cancelled: { label: 'Cancelada', tone: 'secondary', icon: XCircle },
};

export function SubStatusBadge({ status }: { status: string }) {
  const st = SUB_STATUS[status] ?? { label: status, tone: 'secondary' as const, icon: CircleSlash };
  return <StatusBadge label={st.label} tone={st.tone} icon={st.icon} />;
}

const INVOICE_STYLE: Record<string, { tone: Tone; icon: LucideIcon }> = {
  draft: { tone: 'secondary', icon: FilePen },
  issued: { tone: 'default', icon: Send },
  paid: { tone: 'success', icon: CheckCircle2 },
  overdue: { tone: 'destructive', icon: Clock3 },
  void: { tone: 'secondary', icon: Ban },
};

export function InvoiceBadge({ status }: { status: (typeof INVOICE_STATUSES)[number] }) {
  const st = INVOICE_STYLE[status] ?? { tone: 'secondary' as const, icon: FileText };
  return <StatusBadge label={INVOICE_STATUS_LABELS[status]} tone={st.tone} icon={st.icon} />;
}
